import React from 'react';
import { Link } from 'react-router-dom';
import { preloadedLogo } from '../utils/imagePreloader';

// Encabezado blanco de los dos pasos del registro (RegisterData.js y Negocio.js), como el de
// transferisok.com. Los estilos están en pages/Registro.css.
function RegistroHeader({ onAgendar }) {
    return (
        <header className="registro-header">
            <a href="https://transferisok.com/" target="_blank" rel="noopener noreferrer" className="registro-header-logo">
                <img src={preloadedLogo} alt="TransferisOK" />
            </a>
            <nav className="registro-header-acciones">
                <Link to="/login" className="registro-header-ingresar">Ingresar</Link>
                <button type="button" className="registro-header-agendar" onClick={onAgendar}>
                    <span className="registro-solo-escritorio">Agendar llamada</span>
                    <span className="registro-solo-celular">Agendar</span>
                </button>
            </nav>
        </header>
    );
}

export default RegistroHeader;
